import React, { useState, useEffect } from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Table,
    Col,
    Row,
    Button,
    Input,
    FormGroup,
    Label
} from "reactstrap";
import MembersService from "../services/staff.service"
import DHBCreateMember from "../components/Childrens/DHBCreateMembers"
import DHBMemberDetails from "../components/Childrens/DHBMemberDetails"

import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

function Staff() {
    const [listMembers, setListMembers] = useState([])
    const [page, setPage] = useState('')
    const [dataProps, setDataProps] = useState([])
    const [filter, setFilter] = useState("")
    const [listDataFilter, setListDataFilter] = useState([])

    useEffect(() => {
        MembersService.getMembers().then((result) => {
            setListMembers(result.data)
            setListDataFilter(result.data)
        })
    }, [])

    function table() {
        return (
            <Table className="table-hover" style={{ marginTop: "10px", lineHeight: "15px" }}>
                <thead className="text-primary">
                    <tr>
                        <th className="table-device-mobile">ID</th>
                        <th>Tài khoản</th>
                        <th className="table-device-mobile">Email</th>
                        <th>Họ tên</th>
                        <th>Quyền</th>
                    </tr>
                </thead>
                <tbody>
                    {loadFillData()}
                </tbody>
            </Table>
        )
    }

    function toDetailView(val) {
        setPage('detail')
        setDataProps(val)
    }

    function loadFillData() {
        return listMembers.map((data, key) => {
            return (
                <tr onClick={() => toDetailView(data)} style={{ cursor: "pointer" }} key={key}>
                    <th className="table-device-mobile">{data.id}</th>
                    <td>{data.username}</td>
                    <td className="table-device-mobile">{data.email}</td>
                    <td>{data.fullname}</td>
                    <td>{data.role}</td>
                </tr>
            )
        })
    };

    function back() {
        return (
            <Button
                color="secondary"
                style={{ marginBottom: "15px", fontWeight: "bold", width: "120px" }}
                onClick={() => setPage('')}>
                <i className="nc-icon nc-minimal-left" /> Quay lại
            </Button>
        )
    }

    function handleSearch() {
        if (!filter) {
            setListMembers(listDataFilter);
            return;
        }

        const lowerFilter = filter.toLowerCase();
        const result = listDataFilter.filter(item => {
            return (
                (item.username && item.username.toLowerCase().includes(lowerFilter)) ||
                (item.email && item.email.toLowerCase().includes(lowerFilter)) ||
                (item.fullname && item.fullname.toLowerCase().includes(lowerFilter)) ||
                (item.id && item.id.toString().toLowerCase().includes(lowerFilter)) ||
                (item.role && item.role.toLowerCase().includes(lowerFilter))
            );
        });
        setListMembers(result);
    }

    return (
        <div className="content">
            {
                page === 'create'
                    ?
                    <>
                        {back()}
                        <DHBCreateMember />
                    </>
                    :
                    page === "detail"
                        ?
                        <>
                            {back()}
                            <DHBMemberDetails data={dataProps} />
                        </>
                        :
                        <Row>
                            <Col md="12">
                                <Card style={{ backgroundColor: '#fff', borderRadius: '20px', padding: '10px' }}>
                                    <CardHeader>
                                        <CardTitle tag="h4">Quản lý nhân viên</CardTitle>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <Button
                                                color="primary"
                                                style={{ height: "38px", margin: 0, whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}
                                                onClick={() => setPage('create')}>
                                                <i className="nc-icon nc-simple-add" /> Thêm nhân viên mới
                                            </Button>

                                            <div className="d-flex" style={{ width: '400px', maxWidth: '100%' }}>
                                                <Input
                                                    placeholder="Nhập từ khóa tìm kiếm..."
                                                    value={filter}
                                                    onChange={(e) => setFilter(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') handleSearch();
                                                    }}
                                                    style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px', borderRight: 'none', height: '38px' }}
                                                />
                                                <Button
                                                    color="primary"
                                                    style={{ height: "38px", margin: 0, borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}
                                                    onClick={() => handleSearch()}>
                                                    <i className="nc-icon nc-zoom-split" /> Tìm
                                                </Button>
                                            </div>
                                        </div>
                                        {table()}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
            }
        </div>
    )
}

export default Staff